module.exports = __webpack_public_path__ + "static/cosygiraffeblue-75bb6f3fd81f3043041968fd5d3a9ac5.jpeg";